"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportModal = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const input_select_1 = require("../../components/input/input.select");
const input_state_1 = require("../../components/input/input.state");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const form_import_ctrl_1 = require("./form.import.ctrl");
const FORM_IMPORT_SUCCEED = { key: i18n_1.T.FORM_IMPORT_SUCCEED };
const FormImportModalCSS = {
    container: 'c-FormImportModal',
    text: 'c-FormImportModal__text',
    file: 'c-FormImportModal__file',
    form: 'c-FormImportModal__form',
    copyTitle: 'c-FormImportModal__copy-title',
    isActive: 'c-FormImportModal--is-active'
};
(0, theme_1.addStyles)({
    [FormImportModalCSS.form]: {
        width: '100%'
    },
    [FormImportModalCSS.container]: {
        width: '100%',
        height: '100%',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        border: '1px solid ' + theme_1.DefaultTheme.font.color.disabled,
        '&:hover': {
            border: '1px solid ' + theme_1.DefaultTheme.color.accent,
            cursor: 'pointer'
        }
    },
    [FormImportModalCSS.file]: {
        display: 'none'
    },
    [FormImportModalCSS.copyTitle]: {
        marginTop: '10px'
    }
});
class FormImportModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctrl) {
        super({
            title: i18n_1.T.FORM_IMPORT,
            confirm: i18n_1.T.FORM_IMPORT_CONFIRM,
            success: FORM_IMPORT_SUCCEED
        });
        this.loadingSecondaryForms = false;
        this.ctrl = ctrl;
        this.departmentSelectState = new input_select_1.SelectInputState('Department');
        this.departmentSelectState.onValue(() => this.loadSecondaryForms());
        for (const dept of services_1.Services.Department.departments) {
            this.departmentSelectState.addOption({ key: dept.name, value: dept.objectId });
        }
        this.secondaryFormSelectState = new input_select_1.SelectInputState('Form');
        this.secondaryFormSelectState.disabled = true;
        this.secondaryFormSelectState.onValue(formID => { this.ctrl.secondaryFormId = formID; });
        this.fileInputState = new input_state_1.InputState('File');
        this.fileInputState.isRequired = true;
        this.fileInputState.reaction(() => this.ctrl.file && this.ctrl.file.buffer, () => {
            if (this.ctrl.file) {
                this.fileInputState.setValue(this.ctrl.file);
            }
            else {
                this.fileInputState.setError('File is required.');
            }
        });
        this.addState(this.fileInputState);
    }
    loadSecondaryForms() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.departmentSelectState.value) {
                return;
            }
            (0, mobx_1.runInAction)(() => { this.loadingSecondaryForms = true; });
            const deptRest = new core_shared_1.IkeRestDepartment(services_1.Services.User.rest, this.departmentSelectState.value);
            const forms = yield deptRest.formSummaries.fetch();
            this.secondaryFormSelectState.reset();
            for (const form of forms) {
                this.secondaryFormSelectState.addOption({ key: form.displayname, value: form.revision });
            }
            (0, mobx_1.runInAction)(() => { this.loadingSecondaryForms = false; });
        });
    }
    get nodes() {
        let className = FormImportModalCSS.container;
        if (this.ctrl.isActive) {
            className += ' ' + FormImportModalCSS.isActive;
        }
        return (0, mithril_1.m)('form', { className: FormImportModalCSS.form }, [
            ...(this.ctrl.file
                ? [
                    (0, mithril_1.m)('div', [
                        this.ctrl.file.name
                    ])
                ]
                : [
                    (0, mithril_1.m)('input', {
                        className: FormImportModalCSS.file,
                        type: 'file',
                        id: this.ctrl.fileId,
                        onchange: this.ctrl.onFile,
                        accept: form_import_ctrl_1.FormImportCtrl.ALLOWED_SUFFIXES.join(', ')
                    }, ''),
                    (0, mithril_1.m)('div', {
                        className,
                        onclick: this.ctrl.openFileDialog
                    }, [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_UPLOAD_BUTTON)])
                ]),
            (0, mithril_1.m)('div', { className: FormImportModalCSS.copyTitle }, 'Copy custom fields from:'),
            input_select_1.SelectInputComponent.view(this.departmentSelectState),
            this.loadingSecondaryForms ? spinner_1.Spinner.view() : input_select_1.SelectInputComponent.view(this.secondaryFormSelectState)
        ]);
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.ctrl.processFile();
        });
    }
}
exports.FormImportModal = FormImportModal;
tslib_1.__decorate([
    mobx_1.observable
], FormImportModal.prototype, "loadingSecondaryForms", void 0);
//# sourceMappingURL=form.import.modal.js.map